/*currency symbol*/

$( document ).ready(function() {
  $("html").attr("data-page-url", window.location.pathname);
  
  var currencySymbol = $( ".currencies option:selected" ).text();
  var splitCurrencySymbol = currencySymbol.split(' ', 1)[0];
  setTimeout(function() { 
  var checkStr = $( ".nosto_element span.money" ).text();
  if(checkStr.includes('TWD') || checkStr.includes('THB') || checkStr.includes('HK') || checkStr.includes('SGD') ){
  }else{
   $('.nosto_element span.money').append(' ' + splitCurrencySymbol);
  }
  
  }, 2000);

});